import React, {useContext} from 'react'
import {Collapse} from "@material-ui/core";
import FormTranslationContext from "context/FormTranslationContext";
import NoticeGlossaryInput from "../../components/inputs/NoticeGlossaryInput";
import NoticeTextInput from "../../components/inputs/NoticeTextInput";
import NoticeNumericInput from "../../components/inputs/NoticeNumericInput";
import getObjectValue from "libs/getObjectValue";
import NoticeDateTimeInput from "../../components/inputs/NoticeDateTimeInput";
import NoticeDateInput from "../../components/inputs/NoticeDateInput";
import NoticeTypography from "../../components/inputs/NoticeTypography";

function OrderDetailsPrimary(
    {
        id,
        formikProps,
        realizationTypeX11,
        realizationTypeX12,
        realizationTypeX13
    }) {

    const gId = (name) => id + "." + name;
    const gVal = (name, prefix = true, defaultVal = null) => getObjectValue(prefix ? gId(name) : name, formikProps.values, defaultVal);
    const {getDict} = useContext(FormTranslationContext)

  return (<>
        <NoticeTypography formTrKey={id}/>
        <NoticeDateTimeInput
            formikProps={formikProps}
            id={gId("offerEndDate")}
            required
        />

        <NoticeTextInput
            formikProps={formikProps}
            id={gId("offerSubmitPlace")}
            required
        />

        <NoticeDateTimeInput
            formikProps={formikProps}
            id={gId("offerOpenDate")}
            required
        />

        <Collapse in={realizationTypeX11 || realizationTypeX12}>
            <NoticeGlossaryInput
                id={gId("bindWithOffer")}
                formikProps={formikProps}
                items={getDict("ENUM.026")}
                required
            />

            <Collapse in={gVal("bindWithOffer") === "DAYCOUNT"}>
                <NoticeNumericInput
                    formikProps={formikProps}
                    id={gId("bindWithOfferDays")}
                    required
                />
            </Collapse>
            <Collapse in={gVal("bindWithOffer") === "DATE"}>
                <NoticeDateInput
                    formikProps={formikProps}
                    id={gId("bindWithOfferDate")}
                    required
                />
            </Collapse>
        </Collapse>

        <Collapse in={realizationTypeX12 || realizationTypeX13}>
            <NoticeNumericInput
                formikProps={formikProps}
                id={gId("maxSupplierNumber")}
            />
            <NoticeTextInput
                formikProps={formikProps}
                id={gId("limitSuppliersNumberInfo")}
            />
        </Collapse>

        <Collapse in={realizationTypeX13}>
            <NoticeTextInput
                formikProps={formikProps}
                id={gId("noNegotiationsTermsDescription")}
                required
            />
        </Collapse>

    </>)
}

OrderDetailsPrimary.propTypes = {};

export default OrderDetailsPrimary;
